export default __webpack_public_path__ + "static/media/levelTest-Illustration01.dc861586.jpg";